import gql from 'graphql-tag';

import { buildQueryHook } from '../../../utils/buildQueryHook';
import {
  ListLineItems_homework_listLineItems_lineItems as LineItems,
  ListLineItems,
  ListLineItemsVariables,
} from '../../athena/types/ListLineItems';

export const LIST_LINE_ITEMS = gql`
  query ListLineItems($ids: [String!]) {
    homework {
      listLineItems(input: { ids: $ids }) {
        lineItems {
          id
          state
          latestManagerProposedLineItemScope {
            id
            description
            laborCost {
              totalMinutes
              totalCents
            }
            materialCost {
              quantity
              unitCents
              unitLabel
            }
          }
          area {
            id
            label
            value
            section
          }
          feature {
            id
            label
            value
          }
          defect {
            id
            label
            value
          }
        }
      }
    }
  }
`;

export default buildQueryHook<ListLineItems, ListLineItemsVariables, LineItems[] | null>(
  LIST_LINE_ITEMS,
  {
    wrangler: (data) => data?.homework?.listLineItems?.lineItems || null,
  },
);
